import type { LucideIcon } from '@tonnie/assets';

export function SummaryCard({
  label,
  value,
  icon: Icon,
}: {
  label: string;
  value: number;
  icon: LucideIcon;
}) {
  return (
    <div className="text-center p-2 rounded-md bg-background/50">
      <Icon className="w-4 h-4 mx-auto text-muted-foreground mb-1" />
      <div className="text-lg font-bold">{value}</div>
      <div className="text-2xs text-muted-foreground">{label}</div>
    </div>
  );
}
